import React, { useEffect } from "react";

export default function Onboarding() {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = "Muvrrs - Same-Day Delivery App & Onboarding";
    return () => {
      document.title = originalTitle;
    };
  }, []);

  const appUrl = `${process.env.PUBLIC_URL || ""}/onboarding-app/index.html`;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 99999,
        backgroundColor: "#0d1b2a",
        margin: 0,
        padding: 0,
        overflow: "hidden",
      }}
    >
      <iframe
        src={appUrl}
        title="Muvrrs App & Onboarding"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
      />
    </div>
  );
}
